enum ChartTrendType {
  NONE = 'none',
  LINEAR = 'linear',
  EXPONENTIAL = 'exponential',
  LOGARITHMIC = 'logarithmic',
  POLYNOMIAL = 'polynomial',
  TREND = 'trend',
}

export default ChartTrendType;
